import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.concat.js";
import { isWXMiniAppBrowser } from './index';
export function splitOssUrl(url) {
  var _a;

  if ((url === null || url === void 0 ? void 0 : url.indexOf('?ossUrl')) > -1) {
    return (_a = url === null || url === void 0 ? void 0 : url.split('?ossUrl')) === null || _a === void 0 ? void 0 : _a[0];
  }

  return url;
} // 当页面在小程序中打开时，静态替换url地址

export var replaceStateInMiniApp = function replaceStateInMiniApp(data) {
  try {
    if (isWXMiniAppBrowser()) {
      // 获取URL中的参数
      var params = new URLSearchParams(window.location.search); // 需要判断链接上是否已经存在了当前几个参数

      if (!params.get('shareUrl') && (data === null || data === void 0 ? void 0 : data.shareUrl)) {
        params.append('shareUrl', data === null || data === void 0 ? void 0 : data.shareUrl);
      }

      if (!params.get('shareImage') && (data === null || data === void 0 ? void 0 : data.shareImage)) {
        params.append('shareImage', splitOssUrl(data === null || data === void 0 ? void 0 : data.shareImage));
      }

      if (!params.get('shareTitle') && (data === null || data === void 0 ? void 0 : data.shareTitle)) {
        params.append('shareTitle', data === null || data === void 0 ? void 0 : data.shareTitle);
      } // 将新的参数字符串化并附加到URL


      window.history.replaceState({}, '', "".concat(window.location.pathname, "?").concat(params));
    }
  } catch (error) {
    console.log(error);
  }
};